import React, { useContext, useEffect, useState } from "react";
import { GMCContext } from "../../GMCContext";
import axios from "axios";
import Copy from "../Common/Copy";
import Pagination from "../Common/Pagination";

export default function EcosystemReport({ username }) {
  const { formatDateTime } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("send");

  const isSendTab = activeTab === "send";

  const handleTabChange = (tab) => {
    if (tab === activeTab) return;
    setData([]);
    setPages(1);
    setLoading(true);
    setActiveTab(tab);
    setCurrentPage(1);
    setSearch("");
  };

  useEffect(() => {
    if (!username) return;

    let isActive = true;

    const fetchList = async () => {
      setLoading(true);
      setData([]);

      try {
        const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
          method: "user",
          submethod: isSendTab ? "sendeco" : "rcveco",
          key: process.env.REACT_APP_KEY,
          username,
          search,
          page: currentPage,
          pageSize,
        });

        if (!isActive) return;
        if (res.data?.error) {
          setData([]);
          setPages(1);
          return;
        }

        setData(res.data?.data || []);
        setPages(Math.ceil((res.data?.total || 0) / pageSize));
      } catch (err) {
        if (!isActive) return;
        console.log("Error : ", err);
        setData([]);
        setPages(1);
      } finally {
        if (isActive) setLoading(false);
      }
    };

    fetchList();

    return () => {
      isActive = false;
    };
  }, [username, currentPage, pageSize, search, activeTab]);

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <h4 className="card-title mb-0">Ecosystem Report</h4>
                <div className="btn-group" role="group">
                  <button
                    type="button"
                    className={`btn btn-sm ${isSendTab ? "btn-primary" : "btn-outline-primary"
                      }`}
                    onClick={() => handleTabChange("send")}
                  >
                    Send
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${!isSendTab ? "btn-success" : "btn-outline-success"
                      }`}
                    onClick={() => handleTabChange("receive")}
                  >
                    Receive
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="listjs-table" id="customerList">
                <div className="row g-4 mb-3">
                  <div className="col-sm-auto" />
                  <div className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      {/* <div className="search-box ms-2">
                        <input
                          type="text"
                          className="form-control search"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                          }}
                        />
                        <i className="ri-search-line search-icon" />
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="table-responsive table-card mt-3 mb-1">
                  <table className="table align-middle table-nowrap" id="customerTable">
                    <thead className="table-light">
                      <tr>
                        <th className="gridjs-th text-center">#</th>
                        <th className="gridjs-th text-center">
                          {isSendTab ? "Userid" : "Userid"}
                        </th>
                        <th className="gridjs-th text-center">Amount</th>
                        <th className="gridjs-th text-center">Status</th>
                        <th className="gridjs-th text-center">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      ) : data.length > 0 ? (
                        data.map((ele, i) => {
                          const index =
                            currentPage * pageSize - pageSize + (i + 1);
                          const partyValue = isSendTab
                            ? ele.to === null
                              ? "Self"
                              : ele.to || "-"
                            : ele.from || "-";
                          const partyCopy = isSendTab
                            ? ele.to === null
                              ? "-"
                              : ele.to
                            : ele.from;

                          return (
                            <tr key={ele._id || `${activeTab}-${i}`}>
                              <td className="gridjs-td text-center">{index}</td>
                              <td className="gridjs-td text-center">
                                {partyValue}
                                {partyCopy && <Copy data={partyCopy} />}
                              </td>
                              <td className="gridjs-td text-center">
                                $ {ele.amount || "0"}
                              </td>
                              <td className="gridjs-td text-center">
                                <span
                                  className={`badge ${ele.status
                                      ? "bg-success-subtle text-success"
                                      : "bg-warning-subtle text-warning"
                                    } text-uppercase`}
                                >
                                  {ele.to === username || ele.to == null
                                    ? "Receive"
                                    : ele.from === username
                                      ? "Send"
                                      : "Pending"}
                                </span>
                              </td>
                              <td className="gridjs-td text-center">
                                {formatDateTime(ele.date)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            {isSendTab
                              ? "No send records available"
                              : "No receive records available"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  pages={pages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
